import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
    key: 1,
    class: "mg-chat-hover"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "messagesCanvas" };
const _hoisted_5 = ["src"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { key: 0 };
import { ref, watch, onMounted, nextTick } from 'vue';
import { useDarkMode } from '@/composables/useDarkMode';
import { useChatPanel } from '@/composables/useChatPanel';
import SimpleDrawerPanel from '@/components/elements/SimpleDrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatMgButton',
    props: {
        prompt: {},
        bottom: {},
        icon: {},
        hover: { type: Boolean },
        initialPrompt: { type: Boolean },
        size: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const { isDarkMode } = useDarkMode();
        const endRef = ref(null);
        const drawer = ref(false);
        const bottomPos = ref("19%");
        const promptSent = ref(true); // Disable initial prompt
        function scrollToEnd() {
            nextTick(() => {
                if (endRef.value) {
                    endRef.value.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
        const { message, messages, typing, idlePromptShown, userHasTyped, hasUnsentMessages, pushDisclaimer, onKeyPress, sendMessage, sendMessageAndWaitForResponse, formatMessage, applyMonetaryMask, resetInputIdleTimer, clearIdleTimer, attach, sendToWhatsApp, installIosScrollGuard, removeIosScrollGuard, } = useChatPanel({
            isOpen: () => drawer.value,
            scrollToEnd,
        });
        // Optional text pre-fills the input when opening, without overwriting anything already typed.
        function toggleDrawer(prefill) {
            if (!drawer.value && prefill && !message.value)
                message.value = prefill;
            drawer.value = !drawer.value;
        }
        watch(drawer, (open) => {
            if (open) {
                document.body.classList.add('hide-nav-bar');
                idlePromptShown.value = false;
                userHasTyped.value = false;
                resetInputIdleTimer();
                if (props.initialPrompt) {
                    promptSent.value = false;
                }
                if (props.prompt && !promptSent.value) {
                    console.log('Sending initial prompt:', props.prompt);
                    promptSent.value = true;
                    sendMessageAndWaitForResponse(props.prompt, false);
                }
                installIosScrollGuard();
            }
            else {
                document.body.classList.remove('hide-nav-bar');
                clearIdleTimer();
                removeIosScrollGuard();
            }
        });
        function onLoad() {
            if (props.bottom) {
                bottomPos.value = props.bottom;
            }
            pushDisclaimer();
        }
        onMounted(() => {
            onLoad();
            watch(message, () => {
                resetInputIdleTimer();
            });
        });
        __expose({ toggleDrawer });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_textarea = _resolveComponent("v-textarea");
            return (_openBlock(), _createElementBlock("div", {
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => { }, ["stop"]))
            }, [
                (!_ctx.hover && !drawer.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "headerImage",
                        style: _normalizeStyle(_ctx.size ? `width: ${_ctx.size}px` : ''),
                        src: _ctx.icon ? _ctx.icon : (_unref(isDarkMode) ? require('@/assets/AIChat.png') : require('@/assets/AI-Chat-24px.svg')),
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleDrawer()))
                    }, null, 12, _hoisted_1))
                    : _createCommentVNode("", true),
                (_ctx.hover && !drawer.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_v_btn, {
                            class: "imgButton",
                            variant: "text",
                            onClick: _cache[1] || (_cache[1] = ($event) => (toggleDrawer())),
                            style: _normalizeStyle('bottom: ' + bottomPos.value + ' !important;')
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    src: _ctx.icon ? _ctx.icon : require('@/assets/ChatMgButton.png')
                                }, null, 8, _hoisted_3)
                            ]),
                            _: 1
                        }, 8, ["style"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: drawer.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((drawer).value = $event)),
                    title: "Chat MG",
                    direction: "right"
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "inputBarInner",
                            onClick: _cache[5] || (_cache[5] = event => { event.stopPropagation(); })
                        }, [
                            _createVNode(_component_v_textarea, {
                                modelValue: _unref(message),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(message) ? (message).value = $event : null)),
                                class: _normalizeClass(["chatInput", { 'chatInputShrink': _unref(message) && _unref(message).trim() !== '' }]),
                                placeholder: "Enter your message",
                                rows: "1",
                                "max-rows": "5",
                                "auto-grow": "",
                                onKeypress: _unref(onKeyPress),
                                "hide-details": "",
                                onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"])),
                                onKeyup: _withKeys(_unref(sendMessage), ["enter"]),
                                variant: "solo",
                                flat: true,
                                "single-line": "",
                                outlined: "",
                                rounded: "",
                                dense: "",
                                key: "input"
                            }, {
                                "prepend-inner": _withCtx(() => [
                                    _createVNode(_component_v_menu, { location: "top" }, {
                                        activator: _withCtx(({ props: menuProps }) => [
                                            _createVNode(_component_v_icon, _mergeProps(menuProps, {
                                                class: 'sendIcon',
                                                style: { "font-size": "24px", "margin-right": "10px", "color": "#8c8897" }
                                            }), {
                                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                    _createTextVNode("mdi-plus-circle-outline")
                                                ])),
                                                _: 2
                                            }, 1040)
                                        ]),
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_list, {
                                                density: "compact",
                                                style: { "min-width": "180px" }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item, { onClick: _unref(attach) }, {
                                                        prepend: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { style: { "color": "#8c8897" } }, {
                                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                                    _createTextVNode("mdi-paperclip")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                                    _createTextVNode("Attach document")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 8, ["onClick"]),
                                                    _createVNode(_component_v_list_item, {
                                                        onClick: _unref(sendToWhatsApp),
                                                        disabled: !_unref(hasUnsentMessages)
                                                    }, {
                                                        prepend: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                                style: _normalizeStyle('color: ' + (_unref(hasUnsentMessages) ? '#25D366' : '#e2e0e8'))
                                                            }, {
                                                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                    _createTextVNode("mdi-whatsapp")
                                                                ])),
                                                                _: 1
                                                            }, 8, ["style"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                    _createTextVNode("Save this chat to WhatsApp")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 8, ["onClick", "disabled"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                "append-inner": _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                        class: _normalizeClass('sendIcon'),
                                        color: _unref(message) && _unref(message).trim() !== '' ? '#8c8897' : '#e2e0e8',
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_unref(message) && _unref(message).trim() !== '' ? _unref(sendMessage)() : null)),
                                        style: { "font-size": "24px" }
                                    }, {
                                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                                            _createTextVNode("mdi-send-outline")
                                        ])),
                                        _: 1
                                    }, 8, ["color"])
                                ]),
                                _: 1
                            }, 8, ["modelValue", "class", "onKeypress", "onKeyup"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (m) => {
                                return (_openBlock(), _createElementBlock("div", { key: m }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass('message ' + m.direction)
                                    }, [
                                        (m.direction === 'in')
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "message-avatar",
                                                src: require('@/assets/mg.png'),
                                                alt: "MG"
                                            }, null, 8, _hoisted_5))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                            class: "message-content",
                                            innerHTML: _unref(formatMessage)(_unref(applyMonetaryMask)(m.body))
                                        }, null, 8, _hoisted_6)
                                    ], 2)
                                ]));
                            }), 128)),
                            (_unref(typing))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[8] || (_cache[8] = [
                                    _createElementVNode("div", { class: "message in typingIndicator" }, [
                                        _createElementVNode("span", { class: "typingDots" }, [
                                            _createElementVNode("span"),
                                            _createElementVNode("span"),
                                            _createElementVNode("span")
                                        ])
                                    ], -1)
                                ])))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                style: { "clear": "both" },
                                ref_key: "endRef",
                                ref: endRef
                            }, null, 512)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
